import axios from "axios";

export function callApi(url, data, successHandler) {
    let accessToken = localStorage.getItem("accessToken");

    axios({
        method: "post",
        url: url,
        headers: {
            "X-AUTH-TOKEN": accessToken,
        },
        data: data,
        responseType: "json",
        withCredentials: true,
    })
        .then((response) => {
            successHandler(response);
        })
        .catch(function (error) {});
}

export function callPutApi(url, data, token) {
    let accessToken = token['accessToken'];
    axios({
        method: "PUT",
        url: `${process.env.REACT_APP_VIDEO_URL}${url}`,
        headers: {
            "X-AUTH-TOKEN": accessToken,
        },
        data: data,
        withCredentials: true,
    });
}